import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { InfoBannerComponent } from './info-banner.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [
    InfoBannerComponent,
  ],
  declarations: [ InfoBannerComponent],
})
export class  InfoBannerModule {}
